import React from 'react';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import { ButtonToolbar, Button } from 'react-bootstrap';
import { Translate, I18n } from 'react-redux-i18n';
import { isLAP } from '../../actions/root_url';

const getBsStyle = (input, value) => ((input === value) ? 'success' : 'primary');
/* Example of date filter for date range
  {
    dateFilterRadios({
      handleOnClick: this.fetchSalesInvoiceByDetails,
      setFromDate: this.setFromDate,
      setToDate: this.setToDate,
      FromDate: this.state.FromDate,
      ToDate: this.state.ToDate,
      Days: this.state.Days,
    })
  }
*/
const dateFilterRadios = props => (
  <ButtonToolbar className="radio-filter-buttons">
    <Button bsStyle={getBsStyle(props.Days, '1')}>
      <div className="radio">
        <label htmlFor="today-radio-filter1">
          <input
            {...props.input}
            id="today-radio-filter1"
            type="radio"
            name="dateFilterRadios"
            value="1"
            checked={props.Days === '1' || props.Days === 1}
            onChange={() => { props.handleOnClick('1'); }}
          />
          <Translate value="today" />
        </label>
      </div>
    </Button>
    <Button bsStyle={getBsStyle(props.Days, '7')}>
      <div className="radio">
        <label htmlFor="sevenDay-radio-filter1">
          <input
            {...props.input}
            id="sevenDay-radio-filter1"
            type="radio"
            name="dateFilterRadios"
            value="7"
            checked={props.Days === '7' || props.Days === 7}
            onChange={() => { props.handleOnClick('7'); }}
          />
          7 <Translate value="days" />
        </label>
      </div>
    </Button>
    <Button bsStyle={getBsStyle(props.Days, '30')}>
      <div className="radio">
        <label htmlFor="thirtyDay-radio-filter1">
          <input
            {...props.input}
            id="thirtyDay-radio-filter1"
            type="radio"
            name="dateFilterRadios"
            value="30"
            checked={props.Days === '30' || props.Days === 30}
            onChange={() => { props.handleOnClick('30'); }}
          />
          30 <Translate value="days" />
        </label>
      </div>
    </Button>
    <Button bsStyle={getBsStyle(props.Days, '90')}>
      <div className="radio">
        <label htmlFor="ninetyDay-radio-filter1">
          <input
            {...props.input}
            id="ninetyDay-radio-filter1"
            type="radio"
            name="dateFilterRadios"
            value="90"
            checked={props.Days === '90' || props.Days === 90}
            onChange={() => { props.handleOnClick('90'); }}
          />
          90 <Translate value="days" />
        </label>
      </div>
    </Button>
    <Button bsStyle={getBsStyle(props.Days, '-1')}>
      <div className="radio">
        <label htmlFor="dateRange-radio-filter">
          <input
            {...props.input}
            id={ isLAP && props.dateId ? props.dateId : "dateRange-radio-filter"}
            type="radio"
            name="dateFilterRadios"
            value="-1"
            checked={props.Days === '-1' || props.Days === -1}
            onChange={() => { props.setToRangeSearch(); }}
          />
          <Translate value="date_range" />
        </label>
      </div>
    </Button>
    <Button
      bsStyle="primary"
      disabled={props.Days !== '-1' && props.Days !== -1}
    >
      <label htmlFor="dateRange-radio-filter">
        <DateTimePicker
          id="from-datepicker1"
          format="MM-DD-YY"
          className="test-rw-input"
          onChange={(e) => { props.setFromDate(e); }}
          time={false}
          placeholder={I18n.t("start")}
          disabled={props.Days !== '-1' && props.Days !== -1}
          value={props.FromDate}
        />
      </label>
    </Button>
    <Button
      bsStyle="primary"
      disabled={props.Days !== '-1' && props.Days !== -1}
    >
      <label htmlFor="dateRange-radio-filter">
        <DateTimePicker
          id="to-datepicker1"
          format="MM-DD-YY"
          className="test-rw-input"
          onChange={(e) => { props.setToDate(e); }}
          time={false}
          placeholder={I18n.t("end")}
          disabled={props.Days !== '-1' && props.Days !== -1}
          value={props.ToDate}
        />
      </label>
    </Button>
    <Button
      className="search-button"
      bsStyle="primary"
      disabled={(props.Days !== '-1' && props.Days !== -1) || (!props.FromDate || !props.ToDate)}
      onClick={() => { props.handleOnClick('-1'); }}
    >
      <em className="fa fa-search" />
    </Button>
  </ButtonToolbar>
);

dateFilterRadios.propTypes = {
  input: React.PropTypes.node.isRequired,
  handleOnClick: React.PropTypes.func.isRequired,
  setFromDate: React.PropTypes.func.isRequired,
  setToDate: React.PropTypes.func.isRequired,
  FromDate: React.PropTypes.string.isRequired,
  ToDate: React.PropTypes.string.isRequired,
  Days: React.PropTypes.string.isRequired,
  setToRangeSearch: React.PropTypes.func.isRequired,
};

export default dateFilterRadios;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/dateFilterRadios.jsx